export default "__VITE_ASSET__BMP1Q2J6__"